// modules
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

// local
import styles from './Education.pcss';

export default class Education extends PureComponent {
  
  static propTypes = {
    className: PropTypes.string,
    items: PropTypes.arrayOf(PropTypes.shape({
      course: PropTypes.node,
      almaMater: PropTypes.node,
    })),
  }
  static defaultProps = {
    items: [],
  }
  
  get items() {
    const { items } = this.props;
    return items.map(({ course, almaMater }) => (
      <div key={ course } className={ styles.eduItem }>
        <p className={ styles.course }>{ course }</p>
        <p className={ styles.almaMater }>{ almaMater }</p>
      </div>
    ));
  }
  
  render() {
    const { className } = this.props;
    
    const classes = classnames(className, styles.education);
    
    return (
      <div className={ classes }>
        { this.items }
      </div>
    );
  }
  
}



// WEBPACK FOOTER //
// ./src/views/ResumeView/Education/index.jsx